import React, { useEffect, useState } from "react";
import { VAT, entertainmentTax } from "./../../constants";
import { formatNumbers, formatNumbers0 } from "./../../utils/formatNumbers";

const CheckoutReceipt = ({
  tickets = [],
  subtotal = 0,
  addons = [],
  setGrandTotal = () => {},
  showReceipt = true,
  grandTotal = "",
  isFoc = null,
  currency = "",
  discount = 0,
  commission = 0,
}) => {
  let [total, setTotal] = useState(0);
  let [commissionValue, setCommissionValue] = useState(0);
  let [enterTaxValue, setEnterTaxValue] = useState(0);

  useEffect(() => {
    let total = 0;
    let comm = subtotal * (commission / 100);
    let entTax = subtotal * entertainmentTax;
    let proc_fees = 0;
    total = subtotal + comm + proc_fees - discount /*+ entTax */;
    let v = total; /* + total * VAT */
    setGrandTotal(v);
    setTotal(total);
    setEnterTaxValue(entTax);
    setCommissionValue(comm);
  }, [subtotal]);

  return (
    <div className="checkout__receipt">
  {showReceipt && (
    <>
      {/* 
      <table className="receipt-table">
        <colgroup>
          <col className="receipt-table__col--item" />
          <col className="receipt-table__col--qty" />
          <col className="receipt-table__col--sum" />
        </colgroup>
        <thead>
          <tr>
            <th>Item</th>
            <th>Qty</th>
            <th>Sum</th>
          </tr>
        </thead>
        <tbody>
      */}

      {/* HEADER */}
      <div className="receipt-flex receipt-flex__header">
        <div className="receipt-flex__col receipt-flex__col--item">Item</div>
        <div className="receipt-flex__col receipt-flex__col--qty">Qty</div>
        <div className="receipt-flex__col receipt-flex__col--sum">Sum</div>
      </div>

      {/* TICKETS */}
      {tickets.map((ticket, index) => (
        <div className="receipt-flex" key={index}>
          <div className="receipt-flex__col receipt-flex__col--item">
            {ticket.name}
          </div>
          <div className="receipt-flex__col receipt-flex__col--qty">
            x {ticket.quantity}
          </div>
          <div className="receipt-flex__col receipt-flex__col--sum">
            {isFoc
              ? "Free"
              : formatNumbers(ticket.price * ticket.quantity, true) +
                ` ${currency}`}
          </div>
        </div>
      ))}

      {/* ADDONS */}
      {addons.map((addon, index) => (
        <div className="receipt-flex" key={index}>
          <div className="receipt-flex__col receipt-flex__col--item">
            {addon.name}
          </div>
          <div className="receipt-flex__col receipt-flex__col--qty">
            {addon.type !== "bulk" && addon.type !== "fixed"
              ? addon.count
              : ""}
          </div>
          <div className="receipt-flex__col receipt-flex__col--sum">
            {formatNumbers(addon.count * addon.price)} {currency}
          </div>
        </div>
      ))}

      {/* SERVICE CHARGES */}
      {!isFoc && +commissionValue > 0 && (
        <div className="receipt-flex">
          <div className="receipt-flex__col receipt-flex__col--item">
            Service Charges
          </div>
          <div className="receipt-flex__col receipt-flex__col--qty"></div>
          <div className="receipt-flex__col receipt-flex__col--sum">
            {formatNumbers(commissionValue, true)} {currency}
          </div>
        </div>
      )}
            {/*
            <tr>
              <td>Entertainment Tax</td>
              <td></td>
              <td>{formatNumbers(enterTaxValue)} EGP</td>
            </tr>
            <tr>
              <td>VAT</td>
              <td></td>
              <td>{formatNumbers(total * VAT)} EGP</td>
            </tr> 
            }
            {/*currency === "EGP" && (
              <tr>
                <td>Processing Fees</td>
                <td></td>
                <td>{formatNumbers(commissionValue*1.2133)} EGP</td>
              </tr>
            )*/}

      {/* DISCOUNT */}
      {discount > 0 && (
        <div className="receipt-flex">
          <div className="receipt-flex__col receipt-flex__col--item">
            Discount
          </div>
          <div className="receipt-flex__col receipt-flex__col--qty"></div>
          <div className="receipt-flex__col receipt-flex__col--sum">
            - {formatNumbers(discount, true)} {currency}
          </div>
        </div>
      )}

      {/* 
        </tbody>
      </table>
      */}
    </>
  )}
      <div className="checkout__grand-total">
        <h3 className="checkout__grand-total-title">Order total</h3>
        <div className="checkout__grand-total-value">
          <p>
            {isFoc === true
              ? "Free"
              : formatNumbers(grandTotal, true) + ` ${currency}`}
          </p>
        </div>
        {/*   <div
          className={
            "checkout__receipt-toggle" +
            (showReceipt ? " checkout__receipt-toggle--opened" : "")
          }
          onClick={() => setShowReceipt(!showReceipt)}
        >
          {formatNumbers(grandTotal)} EGP
          {showReceipt ? (
            <DropdownIconRed className="checkout__receipt-icon" />
          ) : (
            <DropdownIcon className="checkout__receipt-icon" />
          )}
        </div> */}
      </div>
    </div>
  );
};

export default CheckoutReceipt;
